export enum HoldingTypeEnum{
  joint_tenancy = "JT",
  tenancy_in_common = "TC",
  sole_ownership = "SO",
}